import { ActionError } from 'Interfaces/ActionCreators';
import { call, cancelled, put, takeEvery } from 'redux-saga/effects';
import DocumentApiService from 'Services/Api/Document';

import { getFormRequestContracts } from './actionCreators';

function* handleFormRequestContractsGet({
  payload,
  meta,
}: ReturnType<typeof getFormRequestContracts.request>) {
  try {
    const data = yield call(DocumentApiService.getFormRequestContracts, payload);

    yield put(getFormRequestContracts.success({ contracts: data }, meta));
  } catch (error) {
    yield put(getFormRequestContracts.failure(error as ActionError, meta));
  } finally {
    if (yield cancelled()) {
      yield put(getFormRequestContracts.cancel(undefined, meta));
    }
  }
}

export default [
  takeEvery(getFormRequestContracts.request, handleFormRequestContractsGet),
];
